import styled from "@emotion/styled";

export const StyledTasks = styled.div`
  .loading {
    height: 100dvh;
  }
  .tasks-board {
    display: flex;
    gap: 16px;
    padding: 24px;
    overflow-x: auto;
    align-items: flex-start;
    min-height: calc(100vh - 90px);
    background: white;
  }
  .not-found {
    height: calc(100vh - 200px);
    width: 100%;
  }

  .tasks-column {
    background: #f4f5f7;
    border-radius: 8px;
    width: 280px;
    min-width: 280px;
    display: flex;
    flex-direction: column;
    max-height: calc(100vh - 160px);
    border: 2px solid transparent;
    transition: border-color 0.2s;
  }

  .tasks-column--drag-over {
    border-color: #1677ff;
    background: #e6f4ff;
  }

  .tasks-column__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px 8px;
  }

  .tasks-column__title {
    font-weight: 600;
    font-size: 14px;
    color: #172b4d;
  }

  .tasks-column__count {
    background: #dfe1e6;
    color: #5e6c84;
    border-radius: 10px;
    padding: 0 8px;
    font-size: 12px;
    font-weight: 600;
    min-width: 20px;
    text-align: center;
  }

  .tasks-column__body {
    flex: 1;
    overflow-y: auto;
    padding: 4px 8px;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .tasks-column__footer {
    padding: 8px;
  }

  .task-card {
    background: #fff;
    border-radius: 6px;
    padding: 10px 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: grab;
    box-shadow: 0 1px 3px rgba(9, 30, 66, 0.12);
    border: 2px solid transparent;
    transition:
      box-shadow 0.15s,
      border-color 0.15s,
      opacity 0.15s;
    gap: 8px;

    &:hover {
      box-shadow: 0 4px 8px rgba(9, 30, 66, 0.2);
    }

    &:hover .task-card__menu {
      opacity: 1;
    }

    .task-card__name {
      font-size: 14px;
      color: #172b4d;
      flex: 1;
      word-break: break-word;
      min-width: 0;
      .task-card__id {
        flex-shrink: 0;
        padding: 2px 6px;
        border-radius: 4px;
        background: #f0f2f5;
        color: #595959;
        font-size: 12px;
        font-weight: 600;
        margin-right: 5px;
      }
    }
  }

  .task-placeholder {
    height: 41px;
    background: #fff;
    box-shadow: 0 1px 3px rgba(9, 30, 66, 0.12);
    border-radius: 6px !important;
    margin-bottom: 10px;
    transform: scale(1.05);
  }

  .task-card--dragging {
    opacity: 0.4;
    cursor: grabbing;
  }

  .task-card__menu {
    opacity: 0;
    transition: opacity 0.15s;
    cursor: pointer;
    color: #5e6c84;
    font-size: 16px;
    padding: 2px 4px;
    border-radius: 4px;
    flex-shrink: 0;

    &:hover {
      background: #f0f0f0;
      color: #172b4d;
    }
  }
`;
